export default __webpack_public_path__ + "static/media/login_logo_omnix_white.88940fc7.svg";